export default __webpack_public_path__ + "static/media/our4.982bedb9.png";